import Area, { IArea } from "./Area";
import Application from "../Application";
import { IRouter } from "../runtime/Router";
import ShowRequestsInteractor from "../interactor/requests/ShowRequestsInteractor";
import RequestsPage from "../ui/pages/requests/RequestsPage";

export default class RequestsArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor(application: Application, router: IRouter) {
    super();
    this.application = application;
    this.router = router;
  }

  register(params: any) {
    this.router.registerRoutes({
      path: "/requests",
      page: this.createPage({
        Page: RequestsPage,
        action: this.showRequestsPage.bind(this)
      }),
      options: {
        secure: true
      }
    });
  }

  public showRequestsPage() {
    return this.application.container
      .resolve<ShowRequestsInteractor>("showRequests")
      .execute();
  }
}
